/**
 * D3 implementations of the Chart interface.
 *
 * Bar + Pie/Donut land Week 2; line/area + stacked Week 3; geo + sparkline-
 * table + KPI Week 4. Geo uses d3-geo + topojson-client directly — honest
 * comparison point against @visx/geo (which wraps the same d3-geo primitives).
 */

import type { FullChartProps } from '../types';
import { D3Bar } from './Bar';
import { D3Pie } from './Pie';

export function renderD3Chart(props: FullChartProps): JSX.Element {
  switch (props.type) {
    case 'bar':
      return <D3Bar {...props} />;
    case 'pie':
    case 'donut':
      return <D3Pie {...props} />;
    default:
      throw new Error(
        `D3 implementation for chart type '${props.type}' not yet wired. Land in Week 3 (line/area/stacked) or Week 4 (geo/sparkline-table/kpi).`
      );
  }
}
